import { Link } from "react-router-dom";

export default function FeatureCards() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl bg-foreground-950 p-6 md:p-8 flex flex-col justify-between min-h-[280px] overflow-hidden cursor-pointer"
          >
            <div>
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800">
                <span className="font-heading text-background-50 text-lg font-bold">S</span>
              </div>
            </div>
            <div>
              <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-50 leading-tight">
                Sugargoo<br />Spreadsheet
              </h3>
              <p className="mt-3 text-sm text-foreground-400">
                Official Product Index
              </p>
            </div>
            <div className="absolute bottom-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 opacity-0 group-hover:opacity-100 transition-opacity">
              <i className="ri-arrow-right-up-line text-background-50"></i>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden min-h-[280px] cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Stylish%20hoodie%20and%20sneakers%20displayed%20on%20a%20minimalist%20concrete%20surface%20in%20an%20urban%20loft%20setting%2C%20natural%20side%20lighting%2C%20editorial%20streetwear%20photography%2C%20muted%20grey%20and%20warm%20neutral%20tones%2C%20modern%20cool%20composition&width=800&height=600&seq=feature-buy-v2&orientation=landscape"
              alt="Shop instantly at main store - Buy It Now"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            <div className="absolute top-4 left-4">
              <span className="px-3 py-1.5 bg-background-50/90 backdrop-blur-sm text-foreground-950 text-xs font-semibold rounded-full flex items-center gap-1.5">
                <i className="ri-shopping-bag-line text-sm"></i>
                Buy It Now
              </span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <p className="text-background-50 text-xl md:text-2xl font-heading font-semibold">
                Shop Instantly
              </p>
            </div>
          </a>

          <Link
            to="/blog/sugargoo-spreadsheet-guide"
            className="group relative rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-8 flex flex-col justify-between min-h-[280px] overflow-hidden cursor-pointer hover:border-primary-300 transition-colors"
          >
            <div>
              <span className="px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full">
                SEO Guide
              </span>
            </div>
            <div>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 leading-tight">
                2026 Best Spreadsheet<br />Finds &amp; Tips
              </h3>
              <p className="mt-2 text-sm text-foreground-600">
                Updated weekly with top products
              </p>
            </div>
            <div className="mt-4 h-32 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Open%20laptop%20showing%20colorful%20spreadsheet%20charts%20on%20a%20warm%20wooden%20desk%20with%20a%20notebook%20and%20pen%2C%20morning%20sunlight%2C%20productivity%20photography%2C%20warm%20amber%20and%20wood%20tones%2C%20clean%20organized%20composition&width=600&height=300&seq=feature-blog-v2&orientation=landscape"
                alt="SEO guide thumbnail - Sugargoo Spreadsheet"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}